import React, { Fragment } from 'react';
const steps = [{
  emoji: '🔴',
  title: 'LO QUE HACE EL ÓVULO',
  text: 'Elimina el 70% del hongo visible en la superficie'
}, {
  emoji: '⚠️',
  title: 'LO QUE EL ÓVULO NO PUEDE HACER',
  text: 'Penetrar el BIOFILM: la capa protectora que el hongo construye en menos de 90 minutos'
}, {
  emoji: '🔄',
  title: 'EL RESULTADO',
  text: 'El 30% que sobrevivió dentro del Biofilm se multiplica y vuelve en 7 a 21 días'
}];
export function MechanismSection() {
  return <section className="w-full px-6 py-16 max-w-2xl mx-auto" data-id="element-144">
      <p className="text-brand-magenta text-[11px] font-semibold uppercase tracking-widest mb-3" data-id="element-145">
        Por qué nada funcionó hasta ahora
      </p>
      <h2 className="text-[24px] font-bold text-white mb-10 leading-tight" data-id="element-146">
        El problema no es la Cándida. Es el{' '}
        <span className="text-brand-teal" data-id="element-147">Biofilm.</span>
      </h2>

      <div className="flex flex-col items-center gap-0 mb-10" data-id="element-148">
        {steps.map((step, i) => <Fragment key={i} data-id="element-149">
            <div className="w-full bg-white/[0.06] rounded-2xl p-5 border border-white/[0.08]" data-id="element-150">
              <p className="text-sm font-bold text-white mb-2" data-id="element-151">
                {step.emoji} {step.title}
              </p>
              <p className="text-[15px] text-brand-muted leading-relaxed" data-id="element-152">
                {step.text}
              </p>
            </div>
            {i < steps.length - 1 && <div className="flex flex-col items-center py-1" data-id="element-153">
                <div className="w-px h-6 bg-brand-magenta/50" data-id="element-154" />
                <span className="text-brand-magenta text-lg" data-id="element-155">↓</span>
                <div className="w-px h-2 bg-brand-magenta/50" data-id="element-156" />
              </div>}
          </Fragment>)}
      </div>

      <div className="rounded-xl p-5 mb-6" style={{
      background: 'rgba(0,245,212,0.08)',
      border: '1px solid #00F5D4'
    }} data-id="element-157">
        <p className="text-[15px] text-white leading-relaxed" data-id="element-158">
          💡 Mientras no disolvás el Biofilm primero, cualquier tratamiento que
          uses va a ser parcialmente inútil. <strong data-id="element-159">Siempre.</strong>
        </p>
      </div>

      <p className="text-[15px] text-brand-muted leading-relaxed" data-id="element-160">
        El <strong className="text-white" data-id="element-161">Método pH-ZERO</strong> es el único
        protocolo adaptado a Argentina que ataca el Biofilm, el intestino y la
        alimentación al mismo tiempo. En 21 días.
      </p>
    </section>;
}